import { version } from '../package.json';

export const SDK_NAME = "sentry.javascript.uniapp";
export const SDK_VERSION = version
